module.exports = __webpack_public_path__ + "static/jb-585edec099b984d4ce1d60caec3ca3e6.jpg";